import validateBrandName from '@/services/app-branding/helpers/validateBrandName';
import type AppBrand from '@/services/app-branding/types/AppBrand';

export default function getBrandName(): AppBrand {
    const brandName: string = import.meta.env.VITE_BRAND_NAME;

    validateBrandName(brandName);

    return brandName as AppBrand;
}
